import { render, staticRenderFns } from "./ProgramEdit.vue?vue&type=template&id=1e3c79d0&scoped=true&"
import script from "./ProgramEdit.vue?vue&type=script&lang=js&"
export * from "./ProgramEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProgramEdit.vue?vue&type=style&index=0&id=1e3c79d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c79d0",
  null
  
)

export default component.exports